'use client'

import classnames from 'classnames'
import React, { FC, ReactElement } from 'react'
import styles from './ValidateBrc20.module.css'
import Button from '@/components/button'
import { Inscription } from '@/utils/types/inscription'
import copy from '@/utils/copy'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const ValidateBrc20: FC<{
	className?: string
	owner: string
	inscription: Inscription
	closeButton: ReactElement
	bestinslotVerified?: boolean
}> = (props): ReactElement => {
	const { owner: _owner, inscription, bestinslotVerified } = props
	const bestinslotUrl = `https://bestinslot.xyz/ordinals/inscription/${inscription?.num}`

	return (
		<div className={classnames({ [props.className as any]: !!props?.className }, styles.root)}>
			<div className={styles.brc20Details}>
				<div
					className={styles.brc20Detail}
					onClick={() => copy(inscription?.id)}
					role="button"
					tabIndex={0}
					onKeyDown={onKeyboardClick(() => copy(inscription?.id))}
				>
					<p className={classnames('text-xs', 'regular')}>Inscription ID</p>
					<p className={classnames(styles.brc20Text, 'text-xs', 'regular')}>{inscription?.id}</p>
				</div>
				<div
					className={styles.brc20Detail}
					onClick={() => copy(inscription?.num)}
					role="button"
					tabIndex={0}
					onKeyDown={onKeyboardClick(() => copy(inscription?.num))}
				>
					<p className={classnames('text-xs', 'regular')}>Inscription Number</p>
					<p className={classnames('text-xs', 'regular')}>{inscription?.num}</p>
				</div>
			</div>
			<div className={styles.brc20ButtonContainer}>
				{!bestinslotVerified && (
					<a target="_blank" href={bestinslotUrl}>
						<Button
							background="white"
							size="small"
							className={styles.actionButton}
							loadingClassName={styles.buttonLoader}
						>
							Validate with bestinslot.xyz
						</Button>
					</a>
				)}
				{props?.closeButton}
			</div>
		</div>
	)
}

export default ValidateBrc20
